import axios from 'axios';
import { getToken } from './auth';

export const baseURL = () => {
  const env = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_PRODUCTION_URL : process.env.REACT_APP_DEV_URL;

  return env;
};

const api = axios.create({
  baseURL: baseURL(),
  timeout: 15000
});

api.interceptors.request.use(async config => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  response => {
    const responseType = response.config?.responseType;
    if (responseType === 'blob' || responseType === 'arraybuffer') {
      return response;
    }
    return response.data;
  },
  error => {
    const isAuthRequest = error.config?.url?.includes('authenticate');
    if (error.response?.status === 401 && logoutCallback && !isAuthRequest) {
      logoutCallback();
    }
    return Promise.reject(error);
  }
);

let logoutCallback = null;
export const setLogoutCallback = fn => {
  logoutCallback = fn;
};

export const apiTokenless = axios.create({
  baseURL: baseURL()
});

export default api;
